import React from 'react';
import { usePlan } from '../../contexts/PlanContext';
import { opensPhoneShell } from '../../utils/phoneShell';

/**
 * Picks the student's rebuilt page or the one a college student still has. The choice
 * sits at the route, so neither page carries a branch for the other. `phone` is for a
 * route the phone shell draws bare (a live class): a phone keeps that page.
 */
const DeskSwitch = ({ desk, college, phone }) => {
  const { institution } = usePlan();
  if (institution?.navLayout === 'academic') return college;
  if (phone && opensPhoneShell()) return phone;
  return desk;
};

export default DeskSwitch;
